<template>
  <FlotoContentLoader :loading="loading">
    <div class="flex flex-col flex-1">
      <MTab v-model="currentTab" position="left">
        <MTabPane v-for="tab in allTabs" :key="tab.type" :tab="tab.title">
          <ComponentListContainer
            :resource-id="resourceId"
            :resource="resource"
            :can-edit="!disabled"
            :can-create="!disabled"
            :can-delete="!disabled"
            :type="tab.type"
            :fetch-fn="fetchData"
            :create-fn="createData"
            :update-fn="updateData"
            :delete-fn="deleteData"
            :module-name="moduleName"
          />
        </MTabPane>
      </MTab>
    </div>
  </FlotoContentLoader>
</template>

<script>
import { CustomRulesComputed } from '@state/modules/custom-rules'
import {
  // getComponentsApi,
  createAssetComponentApi,
  updateAssetComponentApi,
  searchAssetComponentsApi,
  deleteAssetComponentApi,
} from '../../asset-api'
import {
  MOBILE_APPLICATION_COMPONENT,
  SOFTWARE_COMPONENT,
  USER_COMPONENT,
} from '../../helpers/asset'
import ComponentListContainer from '../propery-component-list/propery-component-list-container'
import { customFieldAttributesTypePrefix } from '../../helpers/asset-custom-fields'
export default {
  name: 'ComponentContainer',
  components: { ComponentListContainer },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    assetConfigInfo: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      tabs: [],
      // componentList: [],
      componentConfig: [],
      currentTab: undefined,
    }
  },
  computed: {
    ...CustomRulesComputed,
    horizontalTabs() {
      return this.assetConfigInfo.component.filter(
        (c) =>
          [
            SOFTWARE_COMPONENT,
            USER_COMPONENT,
            MOBILE_APPLICATION_COMPONENT,
          ].indexOf(c) === -1
      )
    },
    allTabs() {
      const components = this.horizontalTabs
      return components.map((p) => ({
        type: p,
        title: this.__tc(p),
        key: p,
      }))
    },
  },
  created() {
    this.getSupportData()
  },
  methods: {
    getSupportData() {
      const typePrefix = customFieldAttributesTypePrefix(this.moduleName)
      if (!this.resourceId || !this.resource[`${typePrefix}TypeId`]) {
        return
      }
      this.$nextTick(() => {
        this.currentTab = this.horizontalTabs[0]
      })
      // Promise.all([getComponentsApi(this.resourceId)]).then(([components]) => {
      //   this.componentList = components.discoveryComponentRestList
      //   this.loading = false
      //   this.$nextTick(() => {
      //     this.currentTab = this.horizontalTabs[0]
      //   })
      // })
    },
    fetchData(qual, limit, offset) {
      if (this.currentTab) {
        return searchAssetComponentsApi(
          this.moduleName,
          [],
          this.resourceId,
          this.currentTab,
          limit,
          offset
        )
      }
    },
    createData(data) {
      return createAssetComponentApi(this.moduleName, this.resourceId, {
        ...data,
        type: this.currentTab,
      })
    },
    updateData(data) {
      const message = this[`${this.moduleName}AskForApproval`]
        ? this.$tc('your_request_is_submitted_for_approval')
        : undefined
      return updateAssetComponentApi(this.moduleName, data, message).then(
        (data) => {
          if (
            this[`${this.moduleName}AskForApproval`] &&
            this.resource.checkerApprovalStatus &&
            this.resource.checkerApprovalStatus !== 'pre_approved'
          ) {
            this.$emit('refresh', ['approval'])
          }
          return data
        }
      )
    },
    deleteData(id) {
      return deleteAssetComponentApi(this.moduleName, this.currentTab, id)
    },
  },
}
</script>
